import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Code2, ArrowRight, Copy } from "lucide-react";

// Homepage/attorneys-page banner promoting the embeddable PD widget,
// with a LIVE widget preview rendered in-place.
export default function WidgetPromoSection({ slotId = "widget-promo-preview-slot" }) {
  useEffect(() => {
    const slot = document.getElementById(slotId);
    if (!slot || slot.dataset.rendered === "1") return;
    slot.dataset.rendered = "1";
    const s = document.createElement("script");
    s.src = `${process.env.REACT_APP_BACKEND_URL}/api/widget/pd.js`;
    s.setAttribute("data-category", "F2A");
    s.setAttribute("data-country", "ALL");
    slot.appendChild(s);
  }, [slotId]);

  return (
    <section
      className="py-16"
      style={{ background: "#1F2937" }}
      data-testid="widget-promo-section"
    >
      <div className="mx-auto max-w-5xl px-6 grid md:grid-cols-2 gap-10 items-center">
        <div>
          <div
            className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold mb-4"
            style={{ background: "rgba(202, 138, 4, 0.15)", color: "#FBBF24" }}
          >
            <Code2 className="w-3.5 h-3.5" /> For immigration attorneys & bloggers
          </div>
          <h2
            className="font-display text-3xl sm:text-4xl font-extrabold mb-3"
            style={{ color: "#FFFFFF" }}
          >
            Free live Visa Bulletin widget<br />
            <span style={{ color: "#FBBF24" }}>for your website.</span>
          </h2>
          <p className="text-[15px] leading-relaxed mb-5" style={{ color: "#D1D5DB" }}>
            One line of code. A live-updating priority-date badge for any category
            and country. Refreshes automatically every month on the 15th when
            the State Department publishes the new bulletin.
          </p>
          <pre
            className="rounded p-3 text-[11.5px] font-mono overflow-x-auto mb-5"
            style={{ background: "#111827", color: "#D1D5DB" }}
          >
{`<script src="https://ds-260usa.com/api/widget/pd.js"
        data-category="F2A" data-country="ALL"
        async></script>`}
          </pre>
          <Link
            to="/widget"
            className="btn-primary inline-flex items-center gap-2 text-sm px-5 py-2.5"
            style={{ background: "#FBBF24", color: "#1F2937" }}
            data-testid="widget-promo-cta"
          >
            <Copy className="w-4 h-4" /> Get your embed snippet
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        <div>
          <div className="text-[11px] font-bold uppercase tracking-wide mb-3" style={{ color: "#9CA3AF" }}>
            Live preview (rendered right here by the widget)
          </div>
          <div
            id={slotId}
            className="p-4 rounded"
            style={{ background: "#F5F0E5" }}
          ></div>
          <div className="mt-4 text-[11px] italic" style={{ color: "#9CA3AF" }}>
            This exact badge — with your chosen category+country — auto-refreshes on your visitors' screens every month.
          </div>
        </div>
      </div>
    </section>
  );
}
